module.exports = __webpack_public_path__ + "img/blood-types.3479fa3b.svg";